export default "__VITE_ASSET__DNiPAJ0l__"